import $ from "jquery";
import ellipsis from '../components/ellipsis.js';

$(document).ready(function () {
    if (window.currentPage == 'expert_project_list') {
        ellipsis({
          element: '.ellipsis2',
        });

        $('#jsNavSider3 .scope, #jsNavSider3 .scope_children').on('click', function (e) {
          e.stopPropagation();
          $('#scope_expert_input').val($(this).data("value"));
          $('#searchProject').submit();
        })

        $("#filterBLock input, #filterBLock select").on('change', function(){
          $('#searchProject').submit();
        })

        $('.jsFavorite').click(function(){
          let that = $(this);
          var type = $(this).data('type');
          var id = $(this).data('id');
          return $.ajax({
            headers: {
              'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            },
            url: '/add-favorite',
            data: {
              'id': id,
              'type': type
            },
            type: 'post',
            dataType: "json",
            beforeSend: function () {
              that.addClass('loading');
            },
          }).done(function (res) {
            that.removeClass('loading');
          });
        });

        $(document).on('click', '.btn-apply-project-detail', function(e) {
          e.preventDefault();
          let url_apply = $(this).attr('data-link');
          $.ajax({
            url: '/expert/ajax/check-expert-apply-project',
            type: 'get',
            dataType: "json",
            }).done(async function (res) {
                if (res.success) {
                  let is_partner = res.is_partner;
                  let is_apply = res.is_apply;
                  let is_company = res.is_company;

                  if (is_partner) {
                    $('#popupInfo').find('.popupContent').find('p').eq(0).addClass('mb0');
                    $('#popupInfo').find('.popupContent').find('p').eq(0).text("パートナー権限のため応募できません（所属する法人にご連絡ください）");
                    $('#popupInfo').find('.popupContent').find('ul').eq(0).html('');
                    $('#popupInfo').find('.popupContent').find('.popupBtn').remove();
                    $('#popupInfo').addClass('show');
                  } else {
                    if (is_apply) {
                      window.location.href = url_apply;
                    } else {
                      if (is_company) {
                        $('#popupInfo').find('.popupContent').find('.popup-title-message').text("「プロフィール編集の必須事項入力」に関しては、法人/個人の「プロフィール」必須事項、個人の「スキル・実績」必須事項を入力してください。");
                        // $('.popupBtn').attr('href', '/expert/profile-company');
                      }
                      $('#popupInfo').addClass('show');
                    }
                  }
                  
                
                }
            }).fail(function (data) {
              let res = JSON.parse(data.responseText);
              if (!res.success) {
                  alert('エラーが発生しました');
              }
            }); 
        });

        $(document).on('click', '.btn-deny-project-detail', function(e) {
          e.preventDefault();
          let project_id = $(this).attr('data-project-id');
          let makeSure = confirm("この案件を見送りますか？");
          if (makeSure) {
            $.ajax({
              url: `/expert/deny-project-assign/${project_id}`,
              type: 'get',
              dataType: "json",
              }).done(async function (res) {
                  if (res.success) {
                    let is_partner = res.is_partner;
                    if (is_partner) {
                      $('#popupInfo').find('.popupContent').find('p').eq(0).addClass('mb0');
                      $('#popupInfo').find('.popupContent').find('p').eq(0).text("パートナー権限のため応募できません（所属する法人にご連絡ください）");
                      $('#popupInfo').find('.popupContent').find('ul').eq(0).html('');
                      $('#popupInfo').find('.popupContent').find('.popupBtn').remove();
                      $('#popupInfo').addClass('show');
                    } else {
                      window.location.reload();
                    }
                  }
              }).fail(function (data) {
                let res = JSON.parse(data.responseText);
                if (!res.success) {
                    alert('エラーが発生しました');
                }
              });
          }
        
        });

        $(document).on('click', '.jsTriggerLinkCustom', function(e) {
          e.preventDefault();
          let link = $(this).find('a.link');
          let url_next = $(link).attr('href');
          let id = $(link).attr('data-proposal-id');
          let type = $(link).attr('data-type');
          if (id) {
            $.ajax({
                headers: {
                  'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                },
                url: '/add-proposal-assign',
                data: {
                  'id': id,
                  'type': type,
                },
                type: 'post',
                dataType: "json",
                success: function(response) {
                    if (response.success) {
                        window.location.href = url_next;
                    }
                },
                error: function(result) {
                  alert('エラーが発生しました');
                }
            });
          } else {
            window.location.href = url_next;
          }
        });
    }
})
